export default __webpack_public_path__ + "media/components/AdEdit/images/vk-like-3e7b27063618b6dd9b8c955e37f3e770.svg";